import React from "react";
import { useApp } from "@/context/AppContext";
import { imgUrl } from "@/lib/api";
import { Heart, Package } from "lucide-react";

export function ProductCard({ product, onOpen }) {
  const { t, lang, favorites, toggleFavorite } = useApp();
  const name = lang === "es" ? product.name_es : product.name_en;
  const isFav = favorites.includes(product.id);
  const available = product.available;
  const img = product.images?.[0];

  return (
    <div
      data-testid={`product-card-${product.id}`}
      className={`group relative rounded-2xl border bg-card overflow-hidden shadow-sm hover:shadow-lg transition-shadow duration-200 animate-fade-up ${
        available ? "cursor-pointer" : "opacity-90"
      }`}
      onClick={() => available && onOpen(product)}
    >
      <div className="relative aspect-[4/5] bg-muted overflow-hidden">
        {img ? (
          <img
            src={imgUrl(img)}
            alt={name}
            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-muted-foreground">
            <Package className="h-12 w-12" />
          </div>
        )}

        <button
          data-testid={`product-favorite-button-${product.id}`}
          onClick={(e) => {
            e.stopPropagation();
            toggleFavorite(product.id);
          }}
          className={`absolute top-3 right-3 h-12 w-12 rounded-full flex items-center justify-center border shadow-sm backdrop-blur transition-colors ${
            isFav
              ? "bg-red-50 text-red-500 dark:bg-red-950/70 dark:text-red-400 border-red-200 dark:border-red-800"
              : "bg-background/80 text-muted-foreground border-border hover:text-red-500"
          }`}
        >
          <Heart className={`h-6 w-6 ${isFav ? "fill-current" : ""}`} />
        </button>

        {!available && (
          <div className="absolute inset-0 bg-background/60 backdrop-blur-[2px] flex items-center justify-center">
            <span
              data-testid={`out-of-stock-badge-${product.id}`}
              className="px-4 py-2 rounded-full text-sm font-bold bg-destructive text-destructive-foreground uppercase tracking-wider shadow-lg"
            >
              {t("outOfStock")}
            </span>
          </div>
        )}
      </div>

      <div className="p-4">
        <h3 className="font-display font-semibold text-base leading-tight line-clamp-2 min-h-[2.6rem]">{name}</h3>
        <div className="mt-2 flex items-center justify-between">
          <span className="font-mono font-bold text-xl text-primary">${product.price.toFixed(2)}</span>
          <span className="text-xs text-muted-foreground">{product.sizes?.length || 0} {t("size").toLowerCase()}s</span>
        </div>
      </div>
    </div>
  );
}
